module.exports = "/_next/static/images/jack-pattern-257b1c1b3014598723d6dfb123cfead4.png";